import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import FlightPageSearchBar from "./Flights/HomePageSearchBar";
import VisaPageSearchBar from "./Visa/HomePage";
import HotelPageSarchBar from "./Hotels/HomePageSearchBar";
import PackagePageSarchBar from "./Packages/HomePageSearchBar";
import "./HomePage.css";

// Which pipeline flag gates each module — mirrors the admin's Region-Modules tabs.
const MODULE_FLAG_KEY = {
  flights: "show_air",
  hotels: "show_hotel",
  packages: "show_packages",
};

// Priority order used only on the bare "/" home route, to pick whichever module
// is actually enabled for the selected region instead of always defaulting to flights.
const MODULE_PRIORITY = ["flights", "hotels", "packages"];

function isModuleEnabledFor(selectedPipeline, moduleType) {
  const flagKey = MODULE_FLAG_KEY[moduleType];
  if (!flagKey) return true;
  // Fail open while the pipeline list/selection hasn't resolved yet.
  return !selectedPipeline || selectedPipeline[flagKey] !== false;
}

export default function HomePage({ type }) {
  const navigate = useNavigate();
  const { pipelinesList, selectedPipelineId } = useSelector((state) => state.user);
  const selectedPipeline = pipelinesList.find(
    (pipeline) => String(pipeline.id) === String(selectedPipelineId)
  );

  // Explicit module routes (/flights, /hotels, /packages) are gated and bounce back
  // to Home when disabled. The bare "/" home route instead picks whichever module
  // is actually enabled — it can't redirect to itself without looping.
  const effectiveType = type || MODULE_PRIORITY.find((m) => isModuleEnabledFor(selectedPipeline, m));

  const isRouteEnabled = !type || isModuleEnabledFor(selectedPipeline, type);

  useEffect(() => {
    if (type && !isRouteEnabled) {
      navigate("/", { replace: true });
    }
  }, [type, isRouteEnabled, navigate]);

  if (type && !isRouteEnabled) {
    return null;
  }

  if (!effectiveType) {
    // Home route, but no module is enabled anywhere for the selected region.
    return (
      <div className="homepage screen">
        <div className="frame-101" style={{ minHeight: "220px" }}>
          <div
            className="frame-203"
            style={{ width: "100%", justifyContent: "center", padding: "80px 20px" }}
          >
            <p
              className="proxima_semibold color_white font25"
              style={{ textAlign: "center", width: "100%" }}
            >
              No modules are available for {selectedPipeline?.name || "this region"} yet.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="homepage screen">
      <div className="frame-101">
        <div className="frame-203">
          <p className="book-international-and-domestic-flights valign-text-bottom proxima_semibold color_white font25">
            Book International And Domestic Flights
          </p>
        </div>

        {effectiveType === "flights" && <FlightPageSearchBar />}
        {effectiveType === "hotels" && <HotelPageSarchBar />}
        {type === "visa" && <VisaPageSearchBar />}
        {effectiveType === "packages" && <PackagePageSarchBar />}

        {/* <OffersSection header={1} /> */}

        {/* <OffersSection header={2} />

        <PopularDestinations /> */}
      </div>
    </div>
  );
}
